<section class="business-benefits">
  <h2>Built to keep <span class="accent">growing</span> with you</h2>
  <p class="section-subtitle">Whatever stage your business is at, orderYaa scales with it.</p>

  <div class="benefits-grid">
    <article class="benefit-card" *ngFor="let benefit of benefits" [style.background]="benefit.gradient">
      <div class="benefit-icon"><i [class]="benefit.icon"></i></div>
      <h3>{{ benefit.title }}</h3>
      <p>{{ benefit.description }}</p>
    </article>
  </div>

  <!-- Ecosystem block -->
  <div class="eco-block">

    <div class="eco-images-row">

      <img src="images/common/rider.png"
           alt="Rider App"
           class="eco-img eco-img--phone" />

      <img src="images/common/pos.png"
           alt="POS System"
           class="eco-img eco-img--pos" />

      <img src="images/common/customer.png"
           alt="Customer App"
           class="eco-img eco-img--phone" />

      <svg class="eco-wires-svg"
           viewBox="0 0 1000 120"
           preserveAspectRatio="none"
           aria-hidden="true">
        <defs>
          <linearGradient id="bbwg1" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   style="stop-color:#009ebf;stop-opacity:0.3"/>
            <stop offset="50%"  style="stop-color:#009ebf;stop-opacity:0.9"/>
            <stop offset="100%" style="stop-color:#009ebf;stop-opacity:0.3"/>
          </linearGradient>
          <linearGradient id="bbwg2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"   style="stop-color:#009ebf;stop-opacity:0.3"/>
            <stop offset="50%"  style="stop-color:#009ebf;stop-opacity:0.9"/>
            <stop offset="100%" style="stop-color:#009ebf;stop-opacity:0.3"/>
          </linearGradient>
        </defs>

        <path id="bbwl" class="eco-wire"
              d="M115,60 Q227,5 440,60"
              fill="none" stroke="url(#bbwg1)" stroke-width="2.5"
              stroke-dasharray="8 4"/>
        <circle r="4" fill="#009ebf" opacity="0.9">
          <animateMotion dur="2s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwl"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.6">
          <animateMotion dur="2s" begin="0.67s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwl"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.3">
          <animateMotion dur="2s" begin="1.33s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwl"/></animateMotion>
        </circle>

        <path id="bbwr" class="eco-wire"
              d="M560,60 Q773,5 885,60"
              fill="none" stroke="url(#bbwg2)" stroke-width="2.5"
              stroke-dasharray="8 4"/>
        <circle r="4" fill="#009ebf" opacity="0.9">
          <animateMotion dur="2s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwr"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.6">
          <animateMotion dur="2s" begin="0.67s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwr"/></animateMotion>
        </circle>
        <circle r="4" fill="#009ebf" opacity="0.3">
          <animateMotion dur="2s" begin="1.33s" repeatCount="indefinite" keyPoints="1;0" keyTimes="0;1" calcMode="linear"><mpath href="#bbwr"/></animateMotion>
        </circle>

      </svg>

    </div>

    <div class="eco-labels-row">
      <p class="eco-label">Rider</p>
      <p class="eco-label eco-label--pos">Store</p>
      <p class="eco-label">Customer</p>
    </div>

  </div>
</section>
